module.exports = __webpack_public_path__ + "img/bcid-symbol-rev.0f7e75d6.svg";